<template>
    <el-dialog
        :title="title"
        :visible="true"
        width="400px"
        custom-class="codelab-popper popper-edit-project"
        :show-close="false"
        :append-to-body="true"
        :before-close="() => this.$emit('close')">
        <el-form class="codelab-form" :model="ruleForm" :rules="rules" label-position="top" ref="ruleForm" @submit.native.prevent="confirm">
            <el-form-item :label="$t('LANG_TEXT_PROJ_NAME')" prop="name">
                <el-input v-model="ruleForm.name" :placeholder="$t('LANG_TEXT_PLACEHODER_PROJECT_NAME')" tabindex="1" autofocus></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" :data-validate="validated" :data-name-validate="nameValidate" :data-version-validate="versionValidate">
            <template v-if="mode === 'save'">
                <span class="popper-footer-button codelab-button gray" @click="close" tabindex="4">{{$t("LANG_BTN_TEXT_CANCEL_SAVE")}}</span>
                <span class="popper-footer-button codelab-button btn" @click="confirm" :class="{'disabled': !validated}" tabindex="5">{{$t("LANG_BTN_TEXT_CONFIRM_SAVE")}}</span>
            </template>
            <template v-else-if="mode === 'another'">
                <span class="popper-footer-button codelab-button gray" @click="close" tabindex="4">{{$t("code-lab/component/popper-edit-project.vue_4")}}</span>
                <span class="popper-footer-button codelab-button btn" @click="confirm" :class="{'disabled': !validated}" tabindex="6">{{$t("code-lab/component/popper-edit-project.vue_3")}}</span>
            </template>
            <template v-else>
                <span class="popper-footer-button codelab-button gray" @click="close" tabindex="4">
                    <!-- {{this.$t( "code-lab/component/popper-edit-project.vue_0" ) }} -->
                    {{ this.$t('button.cancel') }}
                </span>
                <span class="popper-footer-button codelab-button btn" @click="confirm" :class="{'disabled': !validated}" tabindex="3">
                    {{this.$t( "code-lab/component/popper-edit-project.vue_1" ) }}
                </span>
            </template>
        </div>
    </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import saveProjectMix from '@/code-lab/component/mixins/save-project-mix.js'
import MixFileRequestManage  from '@/code-lab/component/file-management/mixins/mix-file-request-manage.js'
export default {
    name: "popper-edit-project",
    mixins: [saveProjectMix, MixFileRequestManage],
    props: {
        title: String,
        mode: String
    },
    data () {
        return {
            nameValidate: true,
            versionValidate: true,
            ruleForm: {
                name: "",
                version: ""
            },
            rules: {
                name: [
                    {
                        validator: (rule, value, callback) => {
                            if (!value.replace( /\s/ig, '' )) {
                                this.nameValidate = false
                                callback(this.$t("LANG_TEXT_PLACEHODER_PROJECT_NAME"))
                                return
                            }
                            
                            const matchChinese = value.match(/[\u4E00-\u9FA5]/g)
                            const tLen = matchChinese ? matchChinese.length : 0
                            const fn = (a, b, max, mode = 1) => {
                                const allLen = (a - b) + (b * 2)
                                if (mode === 1) return allLen > max
                            }
                            if (fn(value.length, tLen, 100)) {
                                this.nameValidate = false
                                callback(this.$t( "code-lab/component/popper-edit-project.vue_2" ))
                            } else if (new RegExp(this.regularVer).test(value)) {
                                this.nameValidate = false
                                callback(this.$t("message.error_project_name"))
                            } else {
                                this.nameValidate = true
                                callback()
                            }
                        }
                    }
                ],
                version: [
                    {
                        validator: (rule, value, callback) => {
                            if (!value) {
                                this.versionValidate = false
                                callback(this.$t("LANG_TEXT_PLACEHODER_PROJECT_VER"))
                                return
                            }
                            
                            if (!/^[a-zA-Z0-9\.]{0,}$/.test(value)) {
                                this.versionValidate = false
                                callback(this.$t("message.error_project_version"))
                            } else {
                                this.versionValidate = true
                                callback()
                            }
                        }
                    }
                ]
            }
        }
    },
    computed: {
        ...mapState({
            workSpace: "workSpace",
            projectData: 'projectData',
            regularVer: "regularVer"
        }),
        validated () {
            return this.nameValidate && this.versionValidate
        }
    },
    created () {
        const { name } = this.projectData
        if (this.mode === "save" || this.mode === 'another' ) {
            this.ruleForm.name = name
        }
    },
    methods: {
        confirm () {
            this.$refs.ruleForm.validate(async validate => {
                if (validate) {
                    const name = this.ruleForm.name
                    if (this.mode === 'new') {
                        let project = await this.add_project({ name })
                        if(project){
                            this.$emit("confirm", { name, projectId: project.projectId });
                        } else {
                            this.close()
                        }
                    } else if (this.mode === 'save' || !this.projectData.projectId) {
                        let project = await this.saveProjectAndExportExecuteUrl({ name })
                        if(!project){
                            this.close()
                        }
                    } else {
                        const scriptDom = window.Blockly.Xml.workspaceToDom(this.workSpace)
                        const script = window.Blockly.Xml.domToText(scriptDom)
                        const materials = this.projectData.materials || [];
                        this.clone_project$(res => {
                            if (res.status && Number(res.status.code) === 0) {
                                const { newProjectId, name } = res.data
                                this.$store.commit("UPDATE_PROJECT_DATA", { name, projectId: newProjectId, script, materials })
                                this.$store.commit("UPDATE_IS_SAVED", true)
                            }
                            this.close()
                        }, { name, projectId: this.projectData.projectId, script: window.nuwa.utils.base64.encode(script) })
                        
                    }
                }
            })
        },
        close () {
            this.$emit("close")
        }
    }
}
</script>

<style lang="scss">
.popper-edit-project.codelab-popper{
    .el-form-item{
        .el-form-item__content{
            .el-input{
                .el-input__inner{
                    text-align: center
                }
            }
        }
    }
}
</style>

